export default __webpack_public_path__ + "static/media/Chevin_Light.2a695f37.ttf";